import React from 'react';
import PropTypes from 'prop-types';

export default function WellnessSoftware({
  softwares,
  swSetupStatus,
  onMindBodyEditClick,
  auth,
}) {
  return (
    <div className="summary-item">
      <div className="summary-item__detail">
        <div className="summary-item__heading">Practice Info</div>
        <div className="summary-item__value">{softwares.info.STUDIO_NAME}</div>
        <div className="summary-item__value">{softwares.info.STUDIO_LOCATION}</div>
        {!softwares?.is_truelark &&
          <div className="summary-item__value">
            Studio ID: {softwares?.info?.STUDIO_ID || auth.studio_id}
          </div>}
        <div className="summary-item__value">
          <span className="message-welcome">{swSetupStatus}</span>
        </div>
      </div>
      <div className="summary-item__actions">
        <button className="btn btn--primary btn--lg" onClick={onMindBodyEditClick}>
          Update
        </button>
      </div>
    </div>
  );
}

WellnessSoftware.defaultProps = {
  onMindBodyEditClick: () => {},
  bookingSoftware: {},
};

WellnessSoftware.propTypes = {
  onMindBodyEditClick: PropTypes.func,
  swSetupStatus: PropTypes.string.isRequired,
  softwares: PropTypes.shape({
    status: PropTypes.string,
    isApproved: PropTypes.bool,
    selectedSoftware: PropTypes.string,
    studioId: PropTypes.string,
    bookerClientId: PropTypes.string,
    otherUsername: PropTypes.string,
    info: PropTypes.shape({
      STUDIO_LOCATION: PropTypes.string,
      STUDIO_NAME: PropTypes.string,
      isLoaded: PropTypes.bool,
    }),
  }).isRequired,
};
